import { render, staticRenderFns } from "./PermissionSwitch.vue?vue&type=template&id=0fa9484b&scoped=true"
import script from "./PermissionSwitch.vue?vue&type=script&lang=js"
export * from "./PermissionSwitch.vue?vue&type=script&lang=js"
import style0 from "./PermissionSwitch.vue?vue&type=style&index=0&id=0fa9484b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9484b",
  null
  
)

export default component.exports